import { useApiPost } from "@ametie/vue-muza-use";

import type { ResetPasswordPayload } from "../types";

export const useResetPasswordRequest = (token: string) => {
  return useApiPost<void, ResetPasswordPayload>(`/auth/password/${token}`, {
    authMode: "public",
  });
};
